import { useMemo } from "react";
import classNames from "classnames";
import Form from "react-bootstrap/Form";
import { AXNUIFormPanelHeaderContainer } from "@iddataweb/idw-common-ui/containers";
import { AXNUIContent, AXNUILayout, AXNUITheme } from "@iddataweb/idw-common-ui/types";
import { AXNUIThemingFormButtonContainer } from "../axnui-theming-form-button-container/axnui-theming-form-button-container";
import styles from "./kbaui-theming-verification-form.less";

type KBAUIThemingVerificationFormProps = {
    axnuiContent: AXNUIContent;
    axnuiLayout: AXNUILayout;
    axnuiTheme: AXNUITheme;
    showKbaRetryMessage: boolean;
};

export const KBAUIThemingVerificationForm = (props: KBAUIThemingVerificationFormProps) => {
    const {
        axnuiContent,
        axnuiLayout,
        axnuiTheme,
        showKbaRetryMessage
    } = props;

    const translatedUserMessage = useMemo(() => {
        if (showKbaRetryMessage) {
            return axnuiContent.kba.retryMessage;
        } else {
            return axnuiContent.kba.helloMessage;
        }
    }, [axnuiContent, showKbaRetryMessage]);

    const exampleQuestions = useMemo(() => {
        return [
            {
                id: 1,
                text: "Example Question 1",
                answers: [
                    { label: "Example Answer 1", value: "a" },
                    { label: "Example Answer 2", value: "b" },
                    { label: "Example Answer 3", value: "c" },
                    { label: "Example Answer 4", value: "d" }
                ]
            }
        ];
    }, []);

    return (
        <div className={styles.verificationForm}>
            <AXNUIFormPanelHeaderContainer
                showTitle={true}
                showDescription={true}
                formPanelContent={axnuiContent.formPanel}
                formPanelLayout={axnuiLayout.formPanel}
                formPanelTheme={axnuiTheme.formPanel}
                idpName={null}
                logoPosition={null}
                logoUrl={null}
                relyingPartyName={null}
                useThemedUI={true}
            />
            <div className={"card-body"}>
                {translatedUserMessage && (
                    <div className={styles.userMessage}>
                        <span>{translatedUserMessage}</span>
                    </div>
                )}
                <div>
                    {exampleQuestions.map(question => (
                        <div id={`question${question.id}-container`} key={`question-${question.id}-container`}>
                            <fieldset role={"radiogroup"} id={`question${question.id}`} className={styles.questionInput}>
                                <legend className={classNames(styles.questionInputHeader, `dd-privacy-mask`)} id={`question${question.id}-label`}>
                                    {question.text} <span className={`required ${styles.required}`}>*</span>
                                </legend>
                                <div className={styles.radioGroupInput}>
                                    {question.answers.map((option, index) => (
                                        <Form.Check
                                            className={styles.radioButton}
                                            value={option.value}
                                            checked={option.value === "a"}
                                            aria-checked={option.value === "a"}
                                            disabled={true}
                                            key={`radio-group-input-${index}`}
                                            type={"radio"}
                                            role={"radio"}
                                            name={`question${question.id}-radio-group`}
                                            id={`question${question.id}-${option.value}-input`}
                                            label={option.label}
                                            aria-label={option.label}
                                            onChange={() => { }}
                                        />
                                    ))}
                                </div>
                            </fieldset>
                        </div>
                    ))}
                </div>
                <AXNUIThemingFormButtonContainer
                    axnuiContent={axnuiContent}
                    axnuiTheme={axnuiTheme}
                    showAsyncButton={false}
                    hasCancelButtonURLEnabled={false}
                />
            </div>
        </div>
    );
};